import { FC } from 'react';

type Props = {
	className?: string;
};

const DollarCircleIconSolid: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='inherit'
			stroke='none'
			className={className}>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2ZM10.5581 5.90698C10.5581 5.59873 10.3082 5.34884 10 5.34884C9.69176 5.34884 9.44186 5.59873 9.44186 5.90698V6.51298C8.98099 6.59327 8.55856 6.77199 8.2168 7.02975C7.74059 7.38893 7.39535 7.92685 7.39535 8.56679C7.39535 9.13079 7.59101 9.65574 8.10207 10.0077C8.56799 10.3285 9.21838 10.4479 10 10.4479C10.7114 10.4479 11.1326 10.5577 11.3648 10.7125C11.5488 10.8351 11.6744 11.0254 11.6744 11.4333C11.6744 11.7804 11.5341 11.9908 11.2866 12.1428C11.0055 12.3154 10.5642 12.4186 10 12.4186C9.48249 12.4186 9.03829 12.2727 8.73875 12.0656C8.43696 11.857 8.32558 11.6243 8.32558 11.4333C8.32558 11.1251 8.07569 10.8752 7.76744 10.8752C7.45919 10.8752 7.2093 11.1251 7.2093 11.4333C7.2093 12.0948 7.5977 12.6338 8.10395 12.9838C8.47751 13.242 8.93939 13.4183 9.44186 13.4937V14.093C9.44186 14.4013 9.69176 14.6512 10 14.6512C10.3082 14.6512 10.5581 14.4013 10.5581 14.093V13.5056C11.034 13.4533 11.4908 13.3273 11.8707 13.0941C12.4313 12.7499 12.7907 12.1887 12.7907 11.4333C12.7907 10.7387 12.5442 10.1572 11.984 9.78374C11.4721 9.44238 10.777 9.33165 10 9.33165C9.29325 9.33165 8.92041 9.21585 8.73518 9.0883C8.59504 8.99178 8.51163 8.85522 8.51163 8.56679C8.51163 8.35428 8.62451 8.12044 8.889 7.92096C9.15371 7.72127 9.54471 7.5814 10 7.5814C10.4553 7.5814 10.8463 7.72127 11.111 7.92096C11.3755 8.12044 11.4884 8.35428 11.4884 8.56679C11.4884 8.87501 11.7383 9.12491 12.0465 9.12491C12.3548 9.12491 12.6047 8.87501 12.6047 8.56679C12.6047 7.92685 12.2594 7.38893 11.7832 7.02975C11.4414 6.77199 11.019 6.59327 10.5581 6.51298V5.90698Z'
				fill='inherit'
			/>
		</svg>
	);
};

export default DollarCircleIconSolid;
